import type { StaffRole } from '@mybusinessmate/schema';

/** One cell: allowed, not allowed, or allowed with a condition ("Their clients", "Admin approves"...). */
export type RoleAccess = true | false | string;

export const ROLE_COLUMNS: { role: StaffRole; label: string }[] = [
  { role: 'admin', label: 'Admin' },
  { role: 'account_manager', label: 'Account manager' },
  { role: 'lead_specialist', label: 'Lead' },
  { role: 'specialist', label: 'Specialist' },
];

/** What each role can do (Figma A16.9). Roles are fixed, so this is read-only reference, not a form. */
export const ROLE_MATRIX: { capability: string; access: Record<StaffRole, RoleAccess> }[] = [
  {
    capability: 'See clients and their work',
    access: {
      admin: 'All',
      account_manager: 'Their clients',
      lead_specialist: 'Tasks they’re on',
      specialist: 'Tasks they’re on',
    },
  },
  {
    capability: 'Create projects and tasks',
    access: { admin: true, account_manager: true, lead_specialist: false, specialist: false },
  },
  {
    capability: 'Work on tasks and send drafts',
    access: { admin: true, account_manager: true, lead_specialist: true, specialist: true },
  },
  {
    capability: 'Approve and publish to the client',
    access: { admin: true, account_manager: true, lead_specialist: true, specialist: false },
  },
  {
    capability: 'Hotfix live fields',
    access: { admin: true, account_manager: true, lead_specialist: true, specialist: 'As a draft' },
  },
  {
    capability: 'Add people to a task',
    access: { admin: true, account_manager: true, lead_specialist: 'Admin approves', specialist: false },
  },
  {
    capability: 'Approve meetings, propose dates',
    access: { admin: true, account_manager: true, lead_specialist: false, specialist: false },
  },
  {
    capability: 'See client logins in the vault',
    access: { admin: true, account_manager: true, lead_specialist: true, specialist: 'If on the task' },
  },
  {
    capability: 'Billing, invoices and refunds',
    access: { admin: true, account_manager: 'View only', lead_specialist: false, specialist: false },
  },
  {
    capability: 'Staff, roles and workspace settings',
    access: { admin: true, account_manager: false, lead_specialist: false, specialist: false },
  },
];
